<template>
  <div class="tusd-wrap wrap-bg">
    <div class="page-title">
      <i class="back-btn" @click="$router.go(-1)"></i>收款账号二维码详情
    </div>
    <cube-scroll class="header-scroll">
      <div class="order-info">
        <div class="page-item">
          <span class="page-item-label">收款人：</span>
          <span class="page-item-content" v-clipboard:copy="BankUser" v-clipboard:success="copySuccess"  
          v-clipboard:error="copyError">{{ BankUser }}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">收款人备注：</span>
          <span class="page-item-content" v-clipboard:copy="BankRemark" v-clipboard:success="copySuccess"
            v-clipboard:error="copyError">{{ BankRemark }}</span>
        </div>
        <div class="page-item">
          <span class="page-item-label">收款账号：</span>
          <span class="page-item-content"  v-clipboard:copy="BankAccount" v-clipboard:success="copySuccess"  
          v-clipboard:error="copyError">{{ BankAccount }}</span>
        </div>
      </div>
      <div class="page-item">
          <span class="page-item-label">金额类型：</span>
          <span class="page-item-content" >{{ AmountType == 1 ? '随机金额' : '固定金额' }}</span>
        </div>
      <div class="page-item" >
        <span class="page-item-label">扫码支付码：</span>
        <span class="page-item-content">
          <span v-if="QRCodeUrl">
            <img style="width: 100px;height: 120px;margin: 10px 0;" :src="imgURL + QRCodeUrl" @click="handleSingelImgClick(imgURL + QRCodeUrl)">
          </span>
          <span v-if="!QRCodeUrl">
            未上传
          </span>
        </span>
      </div>
      <div class="page-item" v-if="AmountType == 1">
        <span class="page-item-label">转账支付码：</span>
        <span class="page-item-content">
          <span v-if="TransferQRCodeUrl">
            <img style="width: 100px;height: 120px;margin: 10px 0;" :src="imgURL + TransferQRCodeUrl" @click="handleSingelImgClick(imgURL + TransferQRCodeUrl)">
          </span>
          <span v-if="!TransferQRCodeUrl">
            未上传
          </span>
        </span>
      </div>
      <div class="page-item" v-if="AmountType == 1">
        <span class="page-item-label">花呗支付码：</span>
        <span class="page-item-content">
          <span v-if="CreditQRCodeUrl">
            <img style="width: 100px;height: 120px;margin: 10px 0;" :src="imgURL + CreditQRCodeUrl" @click="handleSingelImgClick(imgURL + CreditQRCodeUrl)">
          </span>
          <span v-if="!CreditQRCodeUrl">
            未上传
          </span>
        </span>
      </div>
  
    </cube-scroll>
  </div>
</template>

<script>
import '../config';

export default {
  name: "orderQrCodeDetail",
  data() {
    return {
      BankUser:"",
      BankRemark:"",
      BankAccount:"",
      AmountType:1,
      QRCodeUrl:"",
      TransferQRCodeUrl:"",
      CreditQRCodeUrl:"",
      imgURL: _IMGURL_,
    };
  },
  methods: {
    handleImgsClick(index) {
      this.initialIndex = index
      const params = {
        $props: {
          imgs: this.imgs,
          initialIndex: 'initialIndex', // 响应式数据的key名
          loop: false
        },
        $events: {
          change: (i) => {
            // 必须更新 initialIndex
            this.initialIndex = i
          }
        }
      }
      this.$createImagePreview({ ...params }).show()
    },
    handleSingelImgClick(imgUrl) {
      this.$createImagePreview({
        imgs: [imgUrl]
      }).show()
    },
     copySuccess() {
      this.$message.popup("复制成功", 1000);
    },
    copyError() {
      this.$message.popup("复制失败", 1000);
    },
  },
  created() {
    var res = this.$store.state.routerStore.orderQrCodeDetail.params;
    this.BankUser = res.BankUser || "";
    this.BankRemark = res.BankRemark || "";
    this.BankAccount = res.BankAccount || "";
    this.AmountType = res.AmountType || 1;
    this.QRCodeUrl = res.QRCodeUrl || "";
    this.TransferQRCodeUrl = res.TransferQRCodeUrl || "";
    this.CreditQRCodeUrl = res.CreditQRCodeUrl || "";
  }
};
</script>

<style lang="less" scoped>
.order-details {
  position: relative;
  padding: 20px 14px;

  .user-order {
    display: flex;
    align-items: center;
    float: left;
    width: 50%;

    .user-header {
      .header-wrap {
        width: 42px;
        height: 42px;
        margin-right: 16px;
        background: url(../assets/images/header.png) center center no-repeat;
        background-size: cover;
        border-radius: 20px;
      }
    }

    .order-amount {
      margin-bottom: 10px;
      font-size: 16px !important;
      color: #d9e3fd;
    }

    .order-time {
      span {
        display: inline-block;
        font-size: 12px !important;
        color: #96abe4;
      }
    }
  }

  .order-money {
    float: right;
    max-width: 50%;

    .order-money-title {
      margin-bottom: 10px;
      font-size: 16px !important;
      color: #d9e3fd;
    }

    .order-money-amount {
      font-size: 14px !important;
      color: #96abe4;

      span {
        margin-right: 10px;
        font-size: 22px !important;
        color: #28faff;
      }
    }
  }
}

.order-operation {
  margin: 26px 14px 12px;
  padding-bottom: 26px;
  border-bottom: 1px solid rgba(76, 89, 145, 0.6);
}

.notice {
  padding: 0px 14px 16px;
  color: #575f8d;
  font-size: 12px !important;
  line-height: @notice-height;
}
</style>
<style lang="less">
.cube-popup-center .cube-popup-content {
  padding: 12px 30px;
  border-radius: 3px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
}

.cube-dialog-icon i {
  width: auto;
  height: auto;
}
</style>
<style lang="less">
.auth-upload {
  padding: 14px 14px 5px 14px;
  overflow: hidden;

  .upload-title {
    font-size: 15px !important;
    color: #d9e3fd;
  }

  .upload-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .box-wrap {
      width: 48.5%;
      height: 110px;
      padding: 0px;

      .upload-btn {
        padding-top: 14%;
        text-align: center;

        &.pic {
          float: left;
          width: 50%;
        }

        i {
          display: inline-block;
          width: 30px;
          height: 30px;
          background: url(../assets/images/add.svg) center center no-repeat;
        }

        p {
          padding-top: 10px;
          color: #8092c6;
        }
      }

    }
  }

  .upload-notice {
    margin: 14px 0px 36px;
    font-size: 12px !important;
    color: #575f8d;
    line-height: @notice-height;
  }
}

.cube-upload-file-def {
  width: 100%;
  height: 120px;
  z-index: 99;
}

.cube-popup-center .cube-popup-content {
  top: -60%;
}

.startImg {
  width: 100%;
  height: 120px;
  position: relative;
  z-index: 999;

  img {
    width: 100%;
    height: 100%;
  }
}

.cubeic-wrong {
  position: absolute;
  z-index: 2;
  top: -2px;
  right: -2px;
  color: rgba(0, 0, 0, 0.8);
  font-size: 16px;
  background-color: #fff;
  border-radius: 50%;
}

.cubeic-wrong::before {
  display: inline-block;
  -webkit-transform: scale(1.625);
  transform: scale(1.625);
  -webkit-transform-origin: center;
  transform-origin: center;
}

@media screen and (min-width: 380px) {
  .auth-upload {
    .upload-wrap {
      .box-wrap {
        height: 120px;
      }
    }
  }
}

@media screen and (max-width: 370px) {
  .auth-upload {
    .upload-wrap {
      .box-wrap {
        height: 105px;
      }
    }
  }
}

@media screen and (max-width: 320px) {
  .auth-upload {
    .upload-wrap {
      .box-wrap {
        height: 94px;

        .upload-btn {
          p {
            font-size: 13px !important;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.cube-popup-center .cube-popup-content {
  padding: 12px 30px;
  border-radius: 3px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
}

.cube-dialog-icon i {
  width: auto;
  height: auto;
}

.upload-btn.pic {
  float: left;
  width: 50%;

  .picc {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    color: #8092c6;

    img {
      max-width: 150px;
      margin: 0 auto;
      margin-bottom: 15px;
    }

    p {
      font-size: 12px !important
    }
  }
}

.cube-upload-btn {
  position: absolute;
  overflow: hidden;
  width: 100%;
  top: 2%;
}

.imgs-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.imgs-container img {
  width: 120px;
  margin: 20px 20px 20px 20px;
}

.order_icon {
  width: 38px;
  height: 38px;
  margin-right: 15px;
  border-radius: 50px;
}
</style>

<style lang="less">
.pay-remark {
  color: white;
  margin-left: -70px;
}

.radio-wrap {
  display: inline-block;

  .cube-radio-group {
    background-color: transparent;

    &:after {
      border: none;
    }

    .cube-radio {
      &:after {
        border: none;
      }
    }

    .cube-radio-ui {
      &:before {
        color: #8092c6;
      }
    }

    .cube-radio_selected {
      .cube-radio-ui {
        background-color: #00a0de;

        &:before {
          color: #00a0de;
        }

        i {
          &:before {
            width: 100%;
            height: 100%;
            transform: translate(-50%, -50%);
            background: url(/images/selected.png) center center no-repeat;
            background-size: 76%;
          }
        }
      }
    }

    .cube-radio-label {
      color: #d9e3fd;
    }
  }
}
</style>